// src/features/alerts/components/SendAlertButton.tsx
//
// «Enviar alerta» sends a pending alert now. The API keeps that action to full
// access (SuperAdmin/Admin), so the button is shown only to them.

import { useState } from 'react';
import { Button, useRecordContext, useNotify, useDataProvider, useRefresh, useTranslate } from 'react-admin';
import { Send as SendIcon } from '@mui/icons-material';
import { hasResourcePermission } from '@/config/resourceConfig';

export const SendAlertButton = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);

  if (!record || record.isSent || !hasResourcePermission('alerts', 'edit')) return null;

  const handleSend = async () => {
    setLoading(true);
    try {
      await dataProvider.sendAlert(record.id);
      notify(translate('resources.alerts.messages.sendSuccess'), { type: 'success' });
      refresh();
    } catch {
      notify(translate('resources.alerts.messages.sendError'), { type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      label={translate('resources.alerts.actions.send')}
      onClick={handleSend}
      disabled={loading}
      startIcon={<SendIcon />}
    />
  );
};
